// extracted by mini-css-extract-plugin
export default {"tutorialVersionSelector":"tutorialVersionSelector--y-JOX"};